<template>
  <v-navigation-drawer
    :mini-variant="miniNav"
    app
    overflow
    :value="show"
  >
    <v-list
      dense
      class="py-0"
    >
      <v-list-item two-line :class="{'px-12 py-1':!miniNav, 'px-0 pb-2': miniNav}" style="display: sticky; top: 0;">
        <v-img :src="(appDark ? '/images/sh-logo-light.png' : '/images/sh-logo-dark.png')" contain v-if="!miniNav" style="max-width: 160px; min-height: 46px; max-height: 46px;" />
        <v-img :src="'/images/sh-logo-icon.png'" contain v-else style="min-height: 36px; max-height: 36px;" />
      </v-list-item>

      
      <template
        v-for="item in permittedItems"
      >
        <v-list-group
          v-if="item.children && !miniNav"
          :key="item.title"
          no-action
          :group="item.namespace"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in item.children"
            :key="item.title + '-' + subItem.title"
            :to="{name: subItem.link}"
          >
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="subItem.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        

        <v-menu
          v-else-if="item.children"
          :nudge-width="200"
          offset-x
          :key="'menu-' + item.title"
          open-on-hover
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              v-on="on"
              :key="item.title"
              :ripple="false"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>

          <v-card>
            <v-list dense class="py-0">
              <v-list-item
                v-for="subItem in item.children"
                :key="item.title + '-' + subItem.title"
                :to="{name: subItem.link}"
              >
                <v-list-item-icon>
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-list-item
          v-else
          :key="item.title"
          :to="{name: item.link}"
          :exact="(item.link == 'dashboard')"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default {
  name: 'AppMenu',
  props: {
    show: Boolean
  },
  data: () => ({
    appDark: false,
    items: [
      {
        title: 'Dashboard',
        icon: 'mdi-view-dashboard',
        link: 'dashboard'
      },
      {
        title: 'Media',
        icon: 'mdi-folder-image',
        link: 'media',
        perm: 'sh_media_r'
      },
      {
        title: 'Food Search',
        icon: 'mdi-food',
        link: 'food-search',
        perm: 'sh_ingredient_r'
      },
      {
        title: 'Admin',
        icon: 'mdi-shield-account',
        namespace: '^/admin',
        role: 'sysadmin',
        children: [
          {
            title: 'Users',
            icon: 'mdi-account-multiple',
            link: 'admin-users'
          },
          {
            title: 'Permissions',
            icon: 'mdi-lock',
            link: 'admin-permissions'
          }
        ]
      }
    ]
  }),
  computed: {
    miniNav: function() {
      return this.$store.getters.setting('navMini');
    },
    permittedItems: function() {
      let list = [];
      for(let i = 0; i < this.items.length; i++) {
        let item = this.items[i];
        if(!item.perm && !item.role) {
          list.push(item);
          continue;
        } else {
          if(this.$store.getters.userCan(item.perm) || this.$store.getters.userIs(item.role)) {
            list.push(item);
            continue;
          }
        }
      }
      return list;
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 32px;
  }
</style>
